export default {
  SEARCH_CATALOG_KUSPIT_COUNTRY_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_COUNTRY_QUERY'),
  CATALOG_KUSPIT_COUNTRY_REPOSITORY: Symbol.for('CATALOG_KUSPIT_COUNTRY_REPOSITORY'),
  CATALOG_KUSPIT_COUNTRY_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_COUNTRY_STATE_MANAGER'),
};
